import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  AssignmentKind,
  AssignmentMoveRequest,
  AssignmentPerson,
  AssignmentState,
} from './assignment.types';

/** Who is dealing with an application — read, move, and who it may go to. */
@Injectable({ providedIn: 'root' })
export class AssignmentService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/api/assignment/ops`;

  get(kind: AssignmentKind, shortId: string): Observable<AssignmentState> {
    return this.http.get<AssignmentState>(`${this.base}/${kind}/${shortId}/`);
  }

  move(
    kind: AssignmentKind,
    shortId: string,
    body: AssignmentMoveRequest,
  ): Observable<AssignmentState> {
    return this.http.post<AssignmentState>(`${this.base}/${kind}/${shortId}/`, body);
  }

  /** *Not now* to "Deal with this?" — remembered for the caller on this record (FLOW-401). */
  notNow(kind: AssignmentKind, shortId: string): Observable<AssignmentState> {
    return this.http.post<AssignmentState>(`${this.base}/${kind}/${shortId}/not-now/`, {});
  }

  assignableUsers(kind: AssignmentKind): Observable<AssignmentPerson[]> {
    return this.http
      .get<{ results: AssignmentPerson[] }>(`${this.base}/${kind}/assignable-users/`)
      .pipe(map((r) => r.results));
  }
}
